
// 全局业务常量

// 需要审批KOL，二级需求类型，KOL类型
export const MUST_KOL_APPROVE_ID = ['1110', '2210']

// 三级单需求类型：合作内容KPI必填，且没有common指标
export const COOPERATE_KPI_REQUIRED_CATEGORY_ID = ['221011', '221010']

// 允许拆单时，选择在库达人
export const ALLOW_SELECT_KOL_CATEGORY_ID = ['221011', '221010']

// 需求类型一级为：效果买量、收口投放、品牌曝光、A+
// 新建需求的时候无需显示采购方式.(同原广告投放）
export const DisablePurchasingMethodType = [10, 19, 20, 21, 27]


export const isNeedPreApprove = ({
                                     purchasing_method
                                 }: {
    purchasing_method: string
}) => {
    // 指定采购和特殊事项采购需要预审
    return ['s_directional_bidding', 's_special_matter_bidding'].includes(purchasing_method);
};

export const isNeedBiding = ({
                                 purchasing_method,
                                 purchasing_strategy
                             }: {
    purchasing_method: string
    purchasing_strategy: string
}) => {
    // 招采
    return purchasing_method === 's_traditional_bidding'
};

export const EXCESS_ACCEPTANCE_NUM = 500;

export const REPORT_URL = 'https://jubao.163.com/';

export enum ORDER_LEVEL_ENUM {
    FIRST = 0,
    SECOND = 1,
    THIRD = 2,
}

export const ORDER_LEVEL_LIST = [
    { name: '一级单', value: ORDER_LEVEL_ENUM.FIRST },
    { name: '二级单', value: ORDER_LEVEL_ENUM.SECOND },
    { name: '三级单', value: ORDER_LEVEL_ENUM.THIRD },
]

export const getCooperateKpiRequired = (categoryId) => {
    const categoryIdStr = categoryId?.toString();
    // 喇叭体系-KOL合作-直播、视频图文
    if (COOPERATE_KPI_REQUIRED_CATEGORY_ID.includes(categoryIdStr)) {
        return true
    }
    // 一级需求类型=创意与素材，下所有的三级需求类型
    if (['13'].some(v => categoryIdStr?.startsWith(v))) {
        return true
    }

    // 二级需求类型=效果买量-效果广告素材，下所有的三级需求类型
    if (['1913'].some(v => categoryIdStr?.startsWith(v))) {
        return true
    }

    return false;
}

/**
 * 判断需求类型是否支持 AI 报价相关字段（是否需整单报价、是否需包含AI 等）
 * 适用类型：创意与素材（l1=13）、效果买量-效果广告素材（l1=19 & l2=1913）
 */
export const getCooperateAIRequired = (categoryId) => {
    const categoryIdStr = categoryId?.toString();

    // 一级需求类型=创意与素材，下所有的三级需求类型
    if (['13'].some(v => categoryIdStr?.startsWith(v))) {
        return true
    }

    // 二级需求类型=效果买量-效果广告素材，下所有的三级需求类型
    if (['1913'].some(v => categoryIdStr?.startsWith(v))) {
        return true
    }

    return false;
}

/**
 * 判断需求类型是否支持 AI 报价相关字段（是否需整单报价、是否需包含AI 等）
 * 适用类型：创意与素材（l1=13）、效果买量-效果广告素材（l1=19 & l2=1913）
 */
export const isSupportAiQuoteCategory = (detail: {
    l1_category_id?: number;
    l2_category_id?: number;
}) => {
    return (
        detail?.l1_category_id === 13 ||
        (detail?.l1_category_id === 19 && detail?.l2_category_id === 1913)
    );
};
